import { parseLocalDate } from "../requests/utilities/helpers";

export function getStartOfCurrentWeek(businessWeekStartDayIndex, date) {
  const targetDate = date ? parseLocalDate(date) : new Date();
  if (!targetDate) {
    return new Date(NaN);
  }

  const startDayIndex = businessWeekStartDayIndex || 0;
  const daysToSubtract = (targetDate.getDay() - startDayIndex + 7) % 7;
  const weekStart = new Date(targetDate);
  weekStart.setDate(targetDate.getDate() - daysToSubtract);
  weekStart.setHours(0, 0, 0, 0);

  return weekStart;
}
